module.exports = __webpack_public_path__ + "img/triangle.3f48e9df.svg";